import React, { useEffect, useState } from "react";

import moment from "moment";
import constant from "../../constant";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { v3_projectMonthlyAttendanceStatus, v3_projectMonthlyAttendanceVerify } from "../../actions/v3/attendance";
import { toast } from "react-toastify";

function transformData(rows, month, year) {
    const daysInMonth = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();

    const users = {};
    rows.forEach(row => {
        if (!users[row.USER_ID]) {
            users[row.USER_ID] = {
                FULL_NAME: row.FULL_NAME,
                USER_ID: row.USER_ID,
                IS_CONFIRMED: row.IS_CONFIRMED,
                ATTENDANCE: {}
            };
        }
        const day = moment(row.DATE).date();
        users[row.USER_ID].ATTENDANCE[day] = {
            from: row.TIME_FROM,
            to: row.TIME_TO,
            remark: row.REMARK
        };
    });

    return { users: Object.values(users), daysInMonth };
}



const AttendanceSheet = ({ rows, month, year, project }) => {
    const { users, daysInMonth } = transformData(rows, month, year);


    const [allUsersConfirmed, setAllUsersConfirmed] = useState(false);
    const [adminVerified, setAdminVerified] = useState(false);

    // ✅ Load status (from backend)
    useEffect(() => {

        v3_projectMonthlyAttendanceStatus(project.PROJECT_ID, month, year).then((res) => {
            if (res.status) {
                debugger
                setAllUsersConfirmed(res.result.allConfirmed);
                setAdminVerified(res.result.adminVerified);
            }
        })

    }, [project, month, year]);

    // ✅ Admin verify handler
    const handleAdminVerify = async () => {
        v3_projectMonthlyAttendanceVerify(project.PROJECT_ID, month, year).then((res) => {
            if (res.status) {
                setAdminVerified(true);
                toast.success("Attendance verified by Admin ✅");
            }
        })

    };
    return (
        <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>S/No</th>
                        <th>Name</th>
                        <th>Designation</th>
                        {Array.from({ length: daysInMonth }, (_, i) => (
                            <th key={i + 1} colSpan="2">
                                {String(i + 1).padStart(2, "0")}-{moment(`${year}-${month}-${i + 1}`).format("MMM")}
                            </th>
                        ))}
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        {Array.from({ length: daysInMonth }, (_, i) => (
                            <React.Fragment key={i + 1}>
                                <th>FROM</th>
                                <th>TO</th>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {users.map((u, idx) => (
                        <tr key={idx}
                            style={{
                                backgroundColor: u.IS_CONFIRMED ? "#d4edda" : "transparent"  // ✅ green if confirmed
                            }}
                        >
                            <td>{idx + 1}</td>
                            <td>
                                <Link
                                    to={{
                                        pathname: constant.Authedcomponent.attendanceMonthlyReportUser.url,
                                        state: {
                                            month: month,
                                            year: year,
                                            project,
                                            userId: u.USER_ID
                                        }
                                    }}
                                >

                                    {u.FULL_NAME}
                                </Link>
                            </td>
                            <td>{u.DESIGNATION || "-"}</td>
                            {
                                Array.from({ length: daysInMonth }, (_, i) => {
                                    const att = u.ATTENDANCE[i + 1];
                                    return (
                                        <React.Fragment key={i + 1}>
                                            <td>{att?.from || ""}</td>
                                            <td>{att?.to || ""}</td>
                                        </React.Fragment>
                                    );
                                })
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="mb-3">
                {allUsersConfirmed && !adminVerified && (
                    <button className="btn btn-success mr-2" onClick={handleAdminVerify}>
                        Verify as Admin
                    </button>
                )}

            </div>
        </div >
    );
};

export default AttendanceSheet;
